// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".option-buttons[data-v-165102ae]{display:flex;justify-content:center}.tree-box[data-v-165102ae]{border:1px solid #e5e6e7;border-radius:4px;width:400px}", ""]);
// Exports
module.exports = exports;
